import { PaymentOrderSource } from './payment-order-source';
import { PaymentService } from './payment-service';
import { TimePeriodUnit } from './time-period-unit';

export const NextPaymentStatus = {
  SCHEDULED: 'SCHEDULED',
  RETRYING: 'RETRYING',
  FAILED: 'FAILED',
} as const;

export type NextPaymentStatus =
  (typeof NextPaymentStatus)[keyof typeof NextPaymentStatus];

export const CompanyProductSubscriptionStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  TERMINATED: 'TERMINATED',
  CANCELLED: 'CANCELLED',
} as const;

export type CompanyProductSubscriptionStatus =
  (typeof CompanyProductSubscriptionStatus)[keyof typeof CompanyProductSubscriptionStatus];

export const SubscriptionSystemSource = {
  API_V1: 'API_V1',
  PAYMENT_ORDER: 'PAYMENT_ORDER',
} as const;

export type SubscriptionSystemSource =
  (typeof SubscriptionSystemSource)[keyof typeof SubscriptionSystemSource];

export type CompanyProductSubscription = {
  id: string;
  subscriptionSystemSource: SubscriptionSystemSource | null;
  orderNumber: string | null;
  nextPaymentChargeDate: string | null;
  nextPaymentStatus: NextPaymentStatus;
  subscriptionStatus: CompanyProductSubscriptionStatus;
  paymentService: PaymentService;
  orderSource: PaymentOrderSource | null;
  creditPurchaseOrderSubscriptionDetail: {
    creditPurchaseOrder: {
      totalPayment: number;
      paymentUrl: string;
    };
  } | null;
};

export type CompanyProductSubscriptionFreeTrialOffer = {
  id: string;
} & (
  | {
      timePeriod: number;
      timePeriodUnit: TimePeriodUnit;
    }
  | {
      timePeriod: null;
      timePeriodUnit: null;
    }
);
